import { replace } from 'lodash/string';

import EncounterTableApi from '../../../../../../../api/study-data/EncounterTableApi';

export default function saveEncounterTableItemGroup(
  isEditMod,
  ssuPatientId,
  patientEncounterId,
  patientItemGroupId,
  encounterTableItemGroup,
  filesToUpload
) {
  const formData = new FormData();
  Object.values(filesToUpload)
    .flatMap(filesWithIds => Object.entries(filesWithIds).map(([fileId, file]) => ({ [fileId]: file })))
    .forEach(fileWithKey => {
      const [[key, value]] = Object.entries(fileWithKey);
      formData.append(key, value);
    });
  formData.append('body', new Blob([JSON.stringify(encounterTableItemGroup)], { type: 'application/json' }));
  return EncounterTableApi[isEditMod ? 'updateEncounterTableItemGroup' : 'saveEncounterTableItemGroup'](
    ssuPatientId,
    patientEncounterId,
    patientItemGroupId,
    formData
  ).catch(function(err) {
    if (err?.response?.data?.message) {
      err.response.data.message = replace(err.response.data.message, '[', '');
      err.response.data.message = replace(err.response.data.message, ']', '');
    }
    throw err;
  });
}
